export enum TerminalSessionStatuses {
    Opened = 'Opened',
    SquareUp = 'SquareUp',
    Closed = 'Closed',
    Interrupted = 'Interrupted'
}
